module.exports = __webpack_public_path__ + "img/20250813SelmaFynn-11.095b44a7.jpg";